document.addEventListener('DOMContentLoaded', function() {
  const multicolumnCards = document.querySelectorAll('.multicolumn-card');
  
  multicolumnCards.forEach(card => {
    const link = card.querySelector('a[href]');
    
    if (link) {
      const href = link.getAttribute('href');
      card.style.cursor = 'pointer';
      
      card.addEventListener('click', function(e) {
        if (e.target.tagName === 'A' || e.target.tagName === 'BUTTON') return;
        window.location.href = href;
      });
    }
  });
});
